import { FC } from 'react';

import Icon from 'molecules/Icon';

import { PricingCellProps } from 'components/Tables/PricingV2/config';

interface TableCellProps extends PricingCellProps {
  iconSize: number;
  // Desktop columns are only tied to their plan visually (CSS alignment under the heading), so each value
  // carries its plan name as hidden text ("Scale: Included") for LLMs / text extractors and screen readers.
  planLabel?: string;
  // Rendered as a <td> inside the desktop <table>; the mobile cards keep the default <div>.
  as?: 'div' | 'td';
}

const TableCell: FC<TableCellProps> = ({ cell, text, iconSize, planLabel, as: Tag = 'div' }) => {
  const planPrefix = planLabel ? <span className="sr-only">{`${planLabel}: `}</span> : null;

  switch (cell) {
    case 'text':
      return (
        <Tag className="flex w-10 items-center justify-end p-0 max-lg:min-w-24 max-lg:max-w-36 lg:w-full lg:justify-center">
          {planPrefix}
          <span className="line-clamp-4 text-right text-sm text-gray-300 lg:w-full lg:text-center lg:text-lg lg:font-medium">
            {text}
          </span>
        </Tag>
      );
    case 'check':
      return (
        <Tag className="flex w-10 items-center justify-center p-0 lg:w-full">
          {planPrefix}
          <Icon icon="green-check" iconColor="text-primary-300" size={iconSize} />
          <span className="sr-only">Included</span>
        </Tag>
      );
    case 'indiscriminate':
      return (
        <Tag className="flex w-10 items-center justify-center p-0 lg:w-full">
          {planPrefix}
          <div className="h-1 w-4 rounded-full bg-white lg:w-6" />
          <span className="sr-only">Not included</span>
        </Tag>
      );
    default:
      return null;
  }
};

export default TableCell;
